import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import CartItem from './CartItem';

function CartAdditionalPorduct(props) {
  const { additionalProduct, ...other } = props;
  return <CartItem
    finalPrice={additionalProduct.price}
    hasAddToCartOption={true}
    hasDeleteOption={false}
    {...other} />;
}

CartAdditionalPorduct.propTypes = {
  additionalProduct: PropTypes.object,
};

export default createFragmentContainer(CartAdditionalPorduct, {
  additionalProduct: graphql`
    fragment CartAdditionalProduct_additionalProduct on Product {
      price
    }
  `,
});
